import React from 'react';
import { Chip } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';

import { VisitType } from '../constants';
import { colors } from '../../../../../../../../themes/colors';

const styles = () =>
  createStyles({
    root: {
      color: colors.white1,
      fontSize: 11,
      fontWeight: 800,
    },
  });

type Props = WithStyles<typeof styles>;

const ModernHealthVisitTypeChip: React.FC<Props> = ({ classes }) => (
  <Chip
    classes={classes}
    color="primary"
    component="span"
    label={VisitType.ModernHealth}
    size="small"
  />
);

export default withStyles(styles)(ModernHealthVisitTypeChip);
